@if (wfReportData) {
  <div class="report-wrapper" #pdfTable id="pdfTable">
    <div class="report-container" [ngClass]="{'report-container-desktop': !isMobile}">
      @if (!isWhitelabel) {
        <ng-container [ngTemplateOutlet]="reportHeaderVsight"></ng-container>
      }
      @if (isWhitelabel) {
        <ng-container [ngTemplateOutlet]="reportHeaderEwers"></ng-container>
      }
      @if (!('electron' | env) && !isMobile) {
        <div class="d-flex justify-content-end align-items-center button-group-report">
          <app-dropdown [imageExist]="true" [width]="dropdownWidth" title="{{selectedLangName ? selectedLangName : 'MAIN.CONTENT.WORKFLOW.LANGUAGE.SELECT-LANGUAGE' | translate}}" style="width: 200px" class="me-2">
            <label class="fs-12 ps-3 text-grey font-weight-600" style="font-size:10px !important">{{ 'MAIN.CONTENT.WORKFLOW.LANGUAGE.ADDED' | translate }}</label>
            @for (lang of workflowLangs; track lang) {
              <div (click)="changeCurrentLang(lang)">
                @if (lang.code) {
                  <div class="lang fs-14  ps-4 pt-2 pb-2 cursor-pointer">
                    <div class="d-flex justify-content-between lang-line">
                      <div>
                        @if (selectedLang == lang.code) {
                          <img src="assets/img/check_icon.svg" alt="" style="margin-left:-22px;">
                        }
                        {{lang.name}}
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </app-dropdown>
          @if (!isMobile) {
            <div class="v-btn btn-primary vsight-button create-button btn me-2" (click)="download()">
              {{ 'MAIN.CONTENT.REPORT.EXPORT' | translate }}
            </div>
          }
          @if (!isMobile) {
            <div class="v-btn btn-primary vsight-button create-button btn" style="margin-right: 50px;" (click)="downloadPDF()">
              {{ 'MAIN.CONTENT.REPORT.SAVE-PDF' | translate }}
            </div>
          }
        </div>
      }
      @if (initialized) {
        <div class="card mt-3" [ngStyle]="{'border' : isMobile ? 'none' : '', 'margin': isMobile ? '0px' : '50px'}">
          <div class="d-flex flex-wrap" [ngClass]="{'scr': !isMobile,'ms-5 me-5':isMobile,'m-100':!isMobile}">
            <div class="col-12 d-flex">
              <div class="col-4 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.NAME' | translate }}</div>
              @if (!workflowPublishedVersion?.translations && workflowPublishedVersion?.name) {
                <div class="col-8 fs-14">: {{workflowPublishedVersion.name}}</div>
              }
              @if (workflowPublishedVersion?.translations) {
                <div class="col-8 fs-14">: {{workflowPublishedVersion?.translations[selectedLang][workflowPublishedVersion.name]}}</div>
              }
            </div>
            <div class="col-12 d-flex">
              <div class="col-4 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.DESCRIPTION' | translate }}</div>
              @if (workflowPublishedVersion?.description && !workflowPublishedVersion?.translations) {
                <div class="col-8 fs-14">: {{workflowPublishedVersion.description}}</div>
              }
              @if (workflowPublishedVersion?.translations && workflowPublishedVersion?.description) {
                <div class="col-8 fs-14">: {{workflowPublishedVersion?.translations[selectedLang][workflowPublishedVersion.description]}}</div>
              }
            </div>
            <div class="col-12 d-flex">
              <div class="col-4 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.STEPS-COMPLETED' | translate }}</div>
              <div class="col-8 fs-14">: {{wfReportData.results.length}}</div>
            </div>
            @if (!wfReportData.continueTimes || !wfReportData.continueTimes?.length) {
              <div class="col-12 d-flex">
                <div class="col-4 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.START' | translate }}</div>
                <div class="col-8 fs-14">: {{wfReportData.startTime | localizedDate | async}}</div>
              </div>
            }
            @if (wfReportData.continueTimes && wfReportData.continueTimes?.length) {
              <div class="col-12 d-flex">
                <div class="col-4 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.PREFILLED-AT' | translate }}</div>
                <div class="col-8 fs-14">: {{wfReportData.startTime | localizedDate | async}}</div>
              </div>
              <div class="col-12 d-flex">
                <div class="col-4 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.QR-SCANNED-AT' | translate }}</div>
                <div class="col-8 fs-14">: {{wfReportData.continueTimes[0].continueTime | localizedDate | async}}</div>
              </div>
            }
            <div class="col-12 d-flex">
              <div class="col-4 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.END' | translate }}</div>
              <div class="col-8 fs-14">: {{wfReportData.endTime | localizedDate | async}}</div>
            </div>
            <div class="col-12 d-flex">
              <div class="col-4 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.DURATION' | translate }}</div>
              <div class="col-8 fs-14">: {{reportDuration}}</div>
            </div>
            @if (wfReportData.continueTimes && wfReportData.continueTimes?.length) {
              <div class="col-12 d-flex">
                <div class="col-4 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.SUBMITTED-BY' | translate }}</div>
                @if (wfReportData.userId && !wfReportData.guest?.email) {
                  <div class="col-8 fs-14">: {{reportUser ? reportUser : getUsersName(wfReportData.userId) }}</div>
                }
                @if (wfReportData.guest?.email) {
                  <div class="col-8 fs-14">: {{wfReportData.guest.email }}</div>
                }
              </div>
            }
          </div>
          @if (!isMobile) {
            <div class="d-flex deneme" [ngStyle]="{'margin': isMobile ? '0px' : '100px'}"  [ngClass]="{'mb-0':$safeNavigationMigration(workflowPublishedVersion.detailExtraFields?.length)>0}">
              <div class="col-6">
                @if (('showSourceBtn' | env) && !isMobile) {
                  <div class="d-flex">
                    <a class="source-icon" (click)="showJsonSource($event, wfReportData)"><i class="mi mi-code" style="font-size: 20px"></i></a>
                  </div>
                }
                <div class="d-flex">
                  <div class="col-md-3 col-sm-6 col-xs-12 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.NAME' | translate }}</div>
                  @if (workflowPublishedVersion?.name && !workflowPublishedVersion?.translations) {
                    <div class="col-md-9 col-sm-6 col-xs-12 fs-15">: {{workflowPublishedVersion.name}}
                    </div>
                  }
                  @if (workflowPublishedVersion?.name && workflowPublishedVersion?.translations) {
                    <div class="col-md-9 col-sm-6 col-xs-12 fs-15">: {{workflowPublishedVersion?.translations[selectedLang][workflowPublishedVersion.name]}}
                    </div>
                  }
                </div>
                <div class="d-flex">
                  <div class="col-md-3 col-sm-6 col-xs-12 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.DESCRIPTION' | translate }}</div>
                  @if (workflowPublishedVersion?.description && !workflowPublishedVersion?.translations) {
                    <div class="col-md-9 col-sm-6 col-xs-12 fs-15">: {{workflowPublishedVersion.description}}
                    </div>
                  }
                  @if (workflowPublishedVersion?.description && workflowPublishedVersion?.translations) {
                    <div class="col-md-9 col-sm-6 col-xs-12 fs-15">: {{workflowPublishedVersion?.translations[selectedLang][workflowPublishedVersion.description]}}
                    </div>
                  }
                </div>
                <div class="d-flex">
                  <div class="col-md-3 col-sm-6 col-xs-12 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.STEPS-COMPLETED' | translate }}</div>
                  <div class="col-md-9 col-sm-6 col-xs-12 fs-15">: {{wfReportData.results.length}}</div>
                </div>
                @if (isAdmin && isEditorMode && wfReportData.continueTimes && wfReportData.continueTimes?.length) {
                  <div class="d-flex">
                    <div class="col-md-3 col-sm-12 col-xs-12 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.PREFILLED-BY' | translate }}</div>
                    <div class="col-md-9 col-sm-6 col-xs-12 fs-15">: {{reportUser ? reportUser : getUsersName(wfReportData.userId) }}</div>
                  </div>
                }
                @if ((isAdmin && isEditorMode) || showSubmittedBy || (wfReportData.continueTimes?.length && (wfReportData.userId || wfReportData.guest))) {
                  <div class="d-flex">
                    <div class="col-md-3 col-sm-12 col-xs-12 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.SUBMITTED-BY' | translate }}</div>
                    @if (wfReportData.userId && !wfReportData.guest?.email) {
                      <div class="col-md-9 col-sm-12 col-xs-12 fs-15">: {{reportUser ? reportUser : getUsersName(wfReportData.userId) }}</div>
                    }
                    @if (wfReportData.guest?.email) {
                      <div class="col-md-9 col-sm-12 col-xs-12 fs-15">: {{wfReportData.guest.email }}</div>
                    }
                  </div>
                }
              </div>
              <div class="col-6">
                @if (wfReportData.continueTimes && wfReportData.continueTimes?.length) {
                  <div class="d-flex">
                    <div class="col-md-3 col-sm-6 col-xs-12 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.PREFILLED-AT' | translate }}</div>
                    <div class="col-md-9 col-sm-6 col-xs-12 fs-15">: {{wfReportData.startTime | localizedDate | async}}</div>
                  </div>
                  <div class="d-flex">
                    <div class="col-md-3 col-sm-6 col-xs-12 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.QR-SCANNED-AT' | translate }}</div>
                    <div class="col-md-9 col-sm-6 col-xs-12 fs-15">: {{wfReportData.continueTimes[0].continueTime | localizedDate | async}}</div>
                  </div>
                }
                @if (!wfReportData.continueTimes || !wfReportData.continueTimes?.length) {
                  <div class="d-flex">
                    <div class="col-md-3 col-sm-6 col-xs-12 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.START' | translate }}</div>
                    <div class="col-md-9 col-sm-6 col-xs-12 fs-15">: {{wfReportData.startTime | localizedDate | async}}</div>
                  </div>
                }
                <div class="d-flex">
                  <div class="col-md-3 col-sm-6 col-xs-12 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.END' | translate }}</div>
                  <div class="col-md-9 col-sm-6 col-xs-12 fs-15">: {{wfReportData.endTime | localizedDate | async}}</div>
                </div>
                <div class="d-flex">
                  <div class="col-md-3 col-sm-6 col-xs-12 fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.DURATION' | translate }}</div>
                  <div class="col-md-9 col-sm-6 col-xs-12 fs-15">: {{reportDuration}}</div>
                </div>
              </div>
            </div>
          }
          @if (workflowPublishedVersion.files?.length>0) {
            <div>
              <hr>
                <div class="d-flex flex-wrap mt-0" style="margin-left:100px;">
                  <div class="col-md-1 col-sm-12 col-xs-12 fs-16 font-weight-500 mt-1">{{ 'MAIN.CONTENT.REPORT.FILES' | translate }}</div>
                  @if (workflowPublishedVersion?.name) {
                    <div class="col-md-10 col-sm-12 col-xs-12 fs-15" style="margin-left:37px;">
                      <div class="d-flex flex-wrap"><span class="mt-1">:</span>
                      @for (file of workflowPublishedVersion.files; track file; let index = $index) {
<div style="padding: 7px;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            border-radius: 10px;" class="ms-1 mb-2 ng-star-inserted card fs-12 font-weight-500">
                          <div><label style="color: #4f5053" ><a [href]="file.url" class="file-attach">{{file.name}}</a></label></div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (workflowPublishedVersion.detailExtraFields?.length>0) {
            <div>
              <hr style="margin-top:3px;">
              <div class="d-flex flex-wrap mt-0" [ngClass]="{'m-100':!isMobile,'ms-5 me-5':isMobile, 'mb-0':(remoteCalls | keyvalue).length>0}">
                @if (!isMobile) {
                  @for (field of workflowPublishedVersion.detailExtraFields; track field; let index = $index) {
                    <div class="col-6 col-xs-12" >
                      <div class="d-flex">
                        <div class="col-3 col-sm-3 col-xs-12 fs-16 font-weight-500">{{ field.templateOptions?.label }}</div>
                        @if (workflowPublishedVersion?.name) {
                          <div class="col-9 col-sm-9 col-xs-12 fs-15">: {{ field.templateOptions?.value }}
                          </div>
                        }
                      </div>
                    </div>
                  }
                }
                @if (isMobile) {
                  @for (field of workflowPublishedVersion.detailExtraFields; track field; let index = $index) {
                    <div class="col-12 col-xs-12" >
                      <div class="d-flex">
                        <div class="col-3 col-sm-4 col-xs-12 fs-16 font-weight-500">{{ field.templateOptions?.label }}</div>
                        @if (workflowPublishedVersion?.name) {
                          <div class="col-9 col-sm-8 col-xs-12 fs-15">: {{ field.templateOptions?.value }}
                          </div>
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          }
          @if (isMobile && workflowPublishedVersion.detailExtraFields?.length>0) {
            <hr>
            }
            @if ((remoteCalls | keyvalue).length>0) {
              <hr>
              }
              @if (remoteCallsLoading && remoteCalls) {
                <ng-container [ngTemplateOutlet]="loadingTemplate"></ng-container>
              }
              @if (!remoteCallsLoading && remoteCalls && (remoteCalls | keyvalue).length > 0) {
                <div class="mt-0" [ngStyle]="{'margin': isMobile ? '0px' : '100px'}">
                  <p class="fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.REMOTE-CALL.TITLE' | translate }}</p>
                  @for (remoteCall of remoteCalls | keyvalue ; track remoteCall; let i = $index) {
                    <div [ngClass]="{'remote-call-group' : i !== 0}">
                      <div class="d-flex col-12">
                        <div class="col-6">
                          @if (remoteCall.value['status'] == 'call-not-started') {
                            <div class="d-flex">
                              <div class="col-md-3 col-sm-6 col-xs-12">{{ 'MAIN.CONTENT.REPORT.REMOTE-CALL.STATUS' | translate }}</div>
                              <div class="col-md-9 col-sm-6 col-xs-12 fs-14">: {{ 'MAIN.CONTENT.REPORT.REMOTE-CALL.CALL-FAILED' | translate }}</div>
                            </div>
                          }
                          @if (remoteCall.value?.['stepName']) {
                            <div class="d-flex">
                              <div class="col-md-3 col-sm-6 col-xs-12">{{ 'MAIN.CONTENT.REPORT.REMOTE-CALL.STEP' | translate }}</div>
                              @if (remoteCall.value?.['stepName']) {
                                <div class="col-md-9 col-sm-6 col-xs-12 fs-14">: {{workflowPublishedVersion.translations[selectedLang][remoteCall.value['stepName']]}}</div>
                              }
                            </div>
                          }
                          @if (remoteCall.value['session']?.['joinedUsers']) {
                            <div class="d-flex">
                              <div class="col-md-3 col-sm-6 col-xs-12">{{ 'MAIN.CONTENT.REPORT.REMOTE-CALL.USERS' | translate }}</div>
                              @if (remoteCall.value['session']?.['joinedUsers']) {
                                <div class="col-md-9 col-sm-6 col-xs-12 fs-14">:
                                  @for (joinedUser of remoteCall.value['session']['joinedUsers']; track joinedUser; let userIndex = $index) {
                                    <span>
                                      {{ joinedUser?.name }}
                                      @if (joinedUser?.isGuest) {
                                        <span>({{ 'MAIN.CONTENT.REPORT.REMOTE-CALL.GUEST' | translate }})</span>
                                      }
                                      @if (userIndex + 1 !== remoteCall.value['session']['joinedUsers']['length']) {
                                        <span>,</span>
                                      }
                                    </span>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                        <div class="col-6">
                          <div class="d-flex">
                            <div class="col-md-3 col-sm-6 col-xs-12">{{ 'MAIN.CONTENT.REPORT.REMOTE-CALL.CREATED-AT' | translate }}</div>
                            @if (remoteCall.value['session']?.['create_time']) {
                              <div class="col-md-9 col-sm-6 col-xs-12 fs-14">: {{remoteCall.value['session']['create_time'] | localizedDate | async}}</div>
                            }
                          </div>
                          <div class="d-flex">
                            <div class="col-md-3 col-sm-6 col-xs-12">{{ 'MAIN.CONTENT.REPORT.START' | translate }}</div>
                            @if (remoteCall.value['session']?.['start_time']) {
                              <div class="col-md-9 col-sm-6 col-xs-12 fs-14">: {{remoteCall.value['session']['start_time'] | localizedDate | async}}</div>
                            }
                            @if (!remoteCall.value['session']?.['start_time']) {
                              <div class="col-md-9 col-sm-6 col-xs-12 fs-14">: -</div>
                            }
                          </div>
                          @if (remoteCall.value['session']?.['end_time']) {
                            <div class="d-flex">
                              <div class="col-md-3 col-sm-6 col-xs-12">{{ 'MAIN.CONTENT.REPORT.END' | translate }}</div>
                              @if (remoteCall.value['session']?.['end_time']) {
                                <div class="col-md-9 col-sm-6 col-xs-12 fs-14">: {{remoteCall.value['session']['end_time'] | localizedDate | async}}</div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              <div class="d-flex report-border" [ngClass]="{'report-border-desktop':!isMobile,'ms-5 me-5':isMobile}">
                @if (!isWhitelabel) {
                  <div class="col-4 fs-15 font-weight-600">{{ 'MAIN.CONTENT.REPORT.STEP-LIST.NAME' | translate }}</div>
                }
                <div class="col-6 fs-15 font-weight-600">{{ 'MAIN.CONTENT.REPORT.STEP-LIST.CONTENT' | translate }}</div>
                @if (!isWhitelabel) {
                  <div class="col-2 fs-15 font-weight-600"> {{ 'MAIN.CONTENT.REPORT.STEP-LIST.DURATION' | translate }}</div>
                }
              </div>
              @for (result of wfReportData.results; track result) {
                <div class="d-flex align-items-center report" [ngClass]="{'den':$safeNavigationMigration(result?.['isSection']),'report-desktop':!isMobile,'ms-5 me-5':isMobile, 'flex-wrap': result['parentWorkflow']}">
                  <!-- <ng-container>
                  <div *ngIf="result['parentWorkflow']" class="col-12 fs-16 font-weight-600 mt-2 pb-4" style="border-bottom: solid;">{{result['parentWorkflow']}}</div>
                </ng-container> -->
                @if (!isWhitelabel) {
                  @if (workflowPublishedVersion.translations ) {
                    <div class="col-4" [ngClass]="{'fs-16 font-weight-600':$safeNavigationMigration(result?.['isSection']), 'fs-15 font-weight-500':!result?.['isSection'] , 'ps-5':$safeNavigationMigration(result?.['parentId'])}">{{workflowPublishedVersion.translations[selectedLang][result['stepName']]}}</div>
                  }
                  @if (!workflowPublishedVersion.translations ) {
                    <div class="col-4" [ngClass]="{'fs-16 font-weight-600':$safeNavigationMigration(result?.['isSection']), 'fs-15 font-weight-500':!result?.['isSection'] , 'ps-5':$safeNavigationMigration(result?.['parentId'])}">{{result['stepName']}}</div>
                  }
                }
                <div [ngClass]="{'col-6': !isWhitelabel, 'col-12': isWhitelabel}">
                  @for (item of result.reportArray; track item) {
                    <div class="mt-3">
                      @if (item.data && item.data['label']) {
                        <p class="mb-1 fs-14 font-weight-600">
                          @if (workflowPublishedVersion.translations) {
                            <span>{{workflowPublishedVersion.translations[selectedLang][item.data['label']]}}</span>
                          }
                          @if (!workflowPublishedVersion.translations) {
                            <span>{{ item.data['label']}}</span>
                          }
                        </p>
                      }
                      @if (!item?.data?.value && item.data?.type) {
                        <p class="fs-14 font-weight-500" style="color: #A1A1A1;">{{ 'MAIN.CONTENT.REPORT.STEP-LIST.NO-CONTENT' | translate }}</p>
                      }
                      @if (item?.data?.value) {
                        @if (item.data.type == 'html') {
                          <div class="">
                            <!-- <div class="ql-editor html-widget" [innerHTML]="byPassHTML(item?.data?.value)"></div> -->
                            @if (workflowPublishedVersion.translations[selectedLang][item?.data?.html]) {
                              <div class="ql-editor html-widget" [innerHTML]="byPassHTML(workflowPublishedVersion.translations[selectedLang][item?.data?.html])"></div>
                            }
                            @if (!workflowPublishedVersion.translations[selectedLang][item?.data?.html]) {
                              <div class="ql-editor html-widget" [innerHTML]="byPassHTML($safeNavigationMigration(item?.data?.value))"></div>
                            }
                          </div>
                        }
                        @if (!item.data?.mediaGroup && item.data.type !== 'pdf' && item.data.type !== 'label' && item.data.type !== 'html' && item.data.type !== 'gallery' && item.data.type !== 'datepicker' && item.data.type !== 'multicheckbox' && item.data.type !== 'table' && item.data.type !== 'form') {
                          <div class="fs-14 font-weight-500 text-black">
                            @if (item.data.type == 'radio') {
                              <div>
                                <span class="fs-14 font-weight-600">Options : </span>
                                @for (optionItem of item.data?.options; track optionItem; let i = $index) {
                                  <span>
                                    @if (!workflowPublishedVersion.translations) {
                                      <span>{{optionItem?.label}} </span>
                                    }
                                    @if (workflowPublishedVersion.translations) {
                                      <span>{{workflowPublishedVersion.translations[selectedLang][optionItem?.label]}} </span>
                                    }
                                    @if (i !== item.data?.options?.length-1) {
                                      <span>, </span>
                                    }</span>
                                  }
                                </div>
                              }
                              <img src="assets/img/check1.svg" alt="" class="me-1">
                              @if ((item.data.type =='number' || item.data.type =='input' || item.data.type =='id')) {
                                <span>{{ item.data.value}}</span>
                              }
                              @if (!workflowPublishedVersion.translations && item.data.type !=='number' && item.data.type !=='input') {
                                <span>{{ item.data.value}}</span>
                              }
                              @if (workflowPublishedVersion.translations &&  item.data.type !=='number'  && item.data.type !=='input') {
                                <span>{{workflowPublishedVersion.translations[selectedLang][item.data.value]}} </span>
                              }
                              @if (workflowPublishedVersion.translations &&  item.data.type !=='number'  && item.data.type !=='input' && isArray($safeNavigationMigration(item.data?.value))) {
                                <span>
                                  @for (val of item.data?.values; track val) {
                                    <span>{{workflowPublishedVersion.translations[selectedLang][val]}}</span>
                                  }
                                </span>
                              }
                              @if (item.data.unit) {
                                <span>{{item.data.unit}}</span>
                              }
                            </div>
                          }
                          @if (item.data.type == 'multicheckbox') {
                            <div class="fs-14 font-weight-500 text-black">
                              <div>
                                <span class="fs-14 font-weight-600">Options : </span>
                                @for (optionItem of item.data?.options; track optionItem; let i = $index) {
                                  <span>
                                    @if (!workflowPublishedVersion.translations) {
                                      <span>{{optionItem?.label}} </span>
                                    }
                                    @if (workflowPublishedVersion.translations) {
                                      <span>{{workflowPublishedVersion.translations[selectedLang][optionItem?.label]}} </span>
                                    }
                                    @if (i !== item.data?.options?.length-1) {
                                      <span>, </span>
                                    }</span>
                                  }
                                </div>
                                @if (item.data.value.length>0) {
                                  <img src="assets/img/check1.svg" class="me-1" alt="">
                                }
                                @if (!workflowPublishedVersion.translations) {
                                  <span>
                                    @for (checkboxItem of item.data.values; track checkboxItem; let i = $index) {
                                      <span>
                                        {{checkboxItem}}
                                        @if (i !== item.data.values?.length-1) {
                                          <span>, </span>
                                        }
                                      </span>
                                    }
                                  </span>
                                }
                                @if (workflowPublishedVersion.translations) {
                                  <span>
                                    @for (checkboxItem of item.data.values; track checkboxItem; let i = $index) {
                                      <span>
                                        {{workflowPublishedVersion.translations[selectedLang][checkboxItem]}}
                                        @if (i !== item.data.values?.length-1) {
                                          <span>, </span>
                                        }
                                      </span>
                                    }
                                  </span>
                                }
                                @if (item.data.value.length==0) {
                                  <p class="fs-14 font-weight-500" style="color: #A1A1A1;">{{ 'MAIN.CONTENT.REPORT.STEP-LIST.NO-CONTENT' | translate }}</p>
                                }
                              </div>
                            }
                            @if (!item.data?.mediaGroup && item.data.type !== 'pdf' && item.data.type == 'label') {
                              <p class="fs-14 font-weight-500 mb-0">
                                @if (!workflowPublishedVersion.translations) {
                                  <span>{{ item.data.value}}</span>
                                }
                                @if (workflowPublishedVersion.translations) {
                                  <span>{{workflowPublishedVersion.translations[selectedLang][item.data.value]}} </span>
                                }
                              </p>
                            }
                            @if (item.data.type == 'datepicker' && (item.data.value | typeof)=== 'string') {
                              <p class="fs-14 font-weight-500 mb-0">
                                <img src="assets/img/check1.svg" class="me-1" alt=""> {{ item.data.value}}
                              </p>
                            }
                            @if (item.data.type == 'datepicker' && (item.data.value | typeof)=== 'number') {
                              <p class="fs-14 font-weight-500 mb-0">
                                <img src="assets/img/check1.svg" class="me-1" alt=""> {{ item.data.value | localizedDate | async}}
                              </p>
                            }
                            @if (item?.data.value  && item.data?.type =='ppe') {
                              <p class="fs-14 font-weight-500 text-black">
                                <img [src]="item.data.value.detected ? 'assets/img/check1.svg' : 'assets/img/close.svg'" alt="" class="me-1">
                                {{ item.data.value.detected ? ('MAIN.CONTENT.REPORT.STEP-LIST.DETECTED' | translate) : ('MAIN.CONTENT.REPORT.STEP-LIST.NOT-DETECTED' | translate) }}
                              </p>
                            }
                            @if (item.data?.type =='qr' && item.data.isQrMatch) {
                              <p class="fs-14 font-weight-500 text-black">
                                <img [src]=" item.data.value.detected ? 'assets/img/check1.svg' : 'assets/img/close.svg'" alt="" class="me-1">
                                {{ item.data.value.detected ? ('MAIN.CONTENT.REPORT.STEP-LIST.MATCHED' | translate) : ('MAIN.CONTENT.REPORT.STEP-LIST.NOT-MATCHED' | translate) }}
                              </p>
                            }
                            @if ((item.data.mediaGroup && item.data.type!=='ppe' && item.data.type!=='qr' && !isArray(item.data.value))) {
                              <div class="cursor-pointer p-relative min-200 overflow-scroll" [ngClass]="{'max-w-300': !isWhitelabel}">
                                @if ((item.data.type=='ppe' && item.data.value.link !==null) || item.data.mediaGroup && !isArray(item.data.value)) {
                                  <div class="view">
                                    @if (item.data.type=='image' || (item?.data?.type=='captureImage') || (item?.data?.type=='signature')) {
                                      <img [src]="item.data.value | safeHtml" class="tt" (click)="openMedia(item.data.value,'image')">
                                    }
                                    @if (item?.data?.type=='video' || item?.data?.type=='captureVideo') {
                                      <video [src]="item.data.value | inlineVideoUrl | safeHtml" class="tt" controls playsinline></video>
                                      <div class="video-zoom-button">
                                        <div class="zoom-outline" (click)="openMedia(item.data.value,'video')">
                                          <img src="assets/img/full.svg" alt="" class="zoom">
                                        </div>
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            @if (item.data.type=='ppe' && item.data.value?.link && item.data.value.link !==null) {
                              <div class="cursor-pointer p-relative min-200 overflow-scroll" [ngClass]="{'max-w-300': !isWhitelabel}">
                                @if ((item.data.type=='ppe' && item.data.value.link && item.data.value.link !==null)) {
                                  <div class="view">
                                    @if (item?.data?.type=='ppe' && item.data.value.link !==null) {
                                      <img [src]="item.data.value.link | safeHtml" class="tt" (click)="openMedia(item.data.value.link,'image')">
                                    }
                                  </div>
                                }
                              </div>
                            }
                            @if ((item.data.type=='captureImage') && isArray(item.data.value)) {
                              <div >
                                <div class="html-widget d-flex flex-wrap">
                                  @for (imageItem of item.data.value; track imageItem) {
                                    <div  class="me-2 mb-2 cursor-pointer">
                                      <div class="multiple-image-container">
                                        <div class="multiple-image-div">
                                                <img [src]="imageItem.url | safeHtml" class="tt" (click)="openMedia(imageItem.url,'image')" style="width: 100%;
                                                height: 100%;
                                                object-fit: contain;">
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                            @if (item.data.type=='qr') {
                              <div class="fs-14 font-weight-500 mb-0">
                                @if (item.data.enteredQRValue) {
                                  <div>
                                    <span class="fs-14 font-weight-600">{{'MAIN.CONTENT.REPORT.STEP-LIST.ENTERED-VALUE' | translate}} : </span>
                                    @if (item.data.value?.hasOwnProperty('qr') && item.data.value.qr) {
                                      <span>{{ item.data.enteredQRValue}}</span>
                                    }
                                  </div>
                                }
                                <span class="fs-14 font-weight-600">{{'MAIN.CONTENT.REPORT.STEP-LIST.SCANNED-VALUE' | translate}} : </span>
                                @if (item.data.value?.hasOwnProperty('qr') && item.data.value.qr) {
                                  <span>{{ item.data.value.qr}}</span>
                                }
                                @if (item.data.value && !item.data.value?.hasOwnProperty('qr')) {
                                  <span>{{ item.data.value}}</span>
                                }
                                @if ((item.data.value?.hasOwnProperty('qr') && !item.data.value.qr) || !item.data.value) {
                                  <p class="fs-14 font-weight-500" style="color: #A1A1A1;">{{ 'MAIN.CONTENT.REPORT.STEP-LIST.NO-CONTENT' | translate }}</p>
                                }
                              </div>
                            }
                            @if (item.data?.type=='captureVideo' && isArray(item.data.value)) {
                              <div class="cursor-pointer p-relative min-200 overflow-scroll" [ngClass]="{'max-w-300': !isWhitelabel}">
                                <div class="view">
                                  @for (video of item.data.value; track video) {
                                    <div class="p-relative">
                                      <video [src]="video.url | inlineVideoUrl | safeHtml" class="tt" controls playsinline></video>
                                      <div class="video-zoom-button">
                                        <div class="zoom-outline" (click)="openMedia(video.url,'video')">
                                          <img src="assets/img/full.svg" alt="" class="zoom">
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                            @if (item.data.type == 'pdf') {
                              <div class="fs-14 font-weight-500 cursor-pointer">
                                <div class="cursor-pointer p-relative min-200 overflow-scroll" [ngClass]="{'max-w-400': !isWhitelabel}">
                                  <div class="view">
                                    <div class="tt">
                                      <app-pdf-page
                                        [src]="item.data.value"
                                        [renderText]="true"
                                        [originalSize]="false"
                                        [page]="currentPdfPage"
                                        (pageChange)="pageChanged($event)"
                                        (loaded)="afterLoadComplete($event)"
                                        style="height: 100%;"
                                      ></app-pdf-page>
                                    </div>
                                    <div class="position-absolute-aligned d-flex align-items-center justify-content-center form-image-overlay">
                                      <div class="zoom-outline" (click)="openMedia(item.data.value,'pdf')">
                                        <img src="assets/img/full.svg" alt="" class="zoom">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (item.data.type == 'gallery') {
                              <div class="">
                                <div class="html-widget d-flex flex-wrap">
                                  @for (image of item.data.value; track image) {
                                    <div class="me-2 mb-2 cursor-pointer">
                                      <div class="multiple-image-container">
                                        <div class="multiple-image-div">
                                          @if (image.imgUrl) {
<img [src]="image.imgUrl | safeHtml"  (click)="openMedia(image.imgUrl,'image')" style="width: 100%;
                                                height: 100%;
                                                object-fit: contain;">
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                            @if (item.data.type == 'form') {
                              <ng-container class="mt-3">
                                <div class="fs-14 font-weight-500 cursor-pointer mt-3">
                                  <div class="cursor-pointer p-relative min-200 overflow-scroll" [ngClass]="{'max-w-400': !isWhitelabel}">
                                    <div class="d-flex flex-wrap justify-content-between" [ngClass]="{'flex-column': !isWhitelabel || isMobile}">
                                      @for (form of workflowPublishedVersion?.steps?.[result.stepId]?.data.layouts[0].items[0].templateOptions.formData; track form; let formIndex = $index) {
                                        <div class="grid-container" [ngClass]="{'col-12': isMobile || !isWhitelabel, 'col-6': !isMobile}">
                                          @if (form.label) {
                                            <p class="fs-14 font-weight-600">{{workflowPublishedVersion?.translations[selectedLang]?.[form.label]}}</p>
                                          }
                                          @for (field of form.fields; track field; let fieldIndex = $index) {
                                            <div class="d-flex mb-2 me-3 text-start" style="align-items: end;">
                                              <div [ngClass]="{'col-6': isMobile, 'col-4': !isMobile, 'col-8': isMobile && !isWhitelabel}"><label>{{workflowPublishedVersion?.translations[selectedLang]?.[field.templateOptions.label]}}</label></div>
                                              <div [ngClass]="{'col-6': isMobile, 'col-8': !isMobile }"><input disabled type="text" class="table-form-control" placeholder="{{item.data.value[field.key]}}"></div>
                                            </div>
                                          }
                                          @if ((formIndex == 0 || formIndex == 1 || formIndex == 2) && (isMobile || !isWhitelabel)) {
                                            <hr>
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </ng-container>
                              }
                              @if (item.data.type == 'table') {
                                <div class="fs-14 font-weight-500 cursor-pointer">
                                  <div class="cursor-pointer p-relative min-200 overflow-scroll" [ngClass]="{'max-w-400': !isWhitelabel}">
                                    <div class="view">
                                      <div class="">
                                        <app-table-report [tableData]="item.data.value" [workflowPublishedVersion]="$safeNavigationMigration(workflowPublishedVersion?.steps?.[result.stepId]?.data)" [workflowTranslations]="$safeNavigationMigration(workflowPublishedVersion?.translations)" [selectedLang]="selectedLang"></app-table-report>
                                      </div>
                                      <div class="position-absolute-aligned d-flex align-items-center justify-content-center form-image-overlay">
                                        <div class="zoom-outline" (click)="openTable(item.data.value, $safeNavigationMigration(workflowPublishedVersion?.steps?.[result.stepId]?.data))">
                                          <img src="assets/img/full.svg" alt="" class="zoom">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            }
                          </div>
                        }
                      </div>
                      @if (!isWhitelabel) {
                        <div class="col-2 fs-15 font-weight-500"> {{result['duration']}}</div>
                      }
                    </div>
                  }
                  @if (report.signature) {
                    <div class="approval-header" [ngClass]="{'report-border-desktop':!isMobile,'ms-5 me-5':isMobile}">
                      <label class="fs-16 font-weight-500">{{ 'MAIN.CONTENT.REPORT.APPROVAL.TITLE' | translate }}</label>
                    </div>
                  }
                  @if (report.signature) {
                    <p class="fs-14 font-weight-400 mt-4 mb-4 report-desktop" [ngClass]="{'report-border-desktop':!isMobile,'ms-5 me-5':isMobile}">
                      {{ 'MAIN.CONTENT.REPORT.APPROVAL.DESCRIPTION-TEXT' | translate }}
                    </p>
                  }
                  @if (report.signature?.signers || signatureReportData?.type) {
                    <div class="signature-container">
                      @for (signer of wfReportData.signature.signers; track signer) {
                        <div class="card mb-3 approver-card" [ngClass]="{'report-border-desktop':!isMobile,'ms-0 me-5':isMobile}">
                          <div class="ms-4 fs-14">
                            <div class="d-flex flex-column align-items-start">
                              @if (signer?.name) {
                                <div class="fs-14 font-weight-600">
                                  {{signer.name}}
                                </div>
                              }
                              <div class="fs-14">
                                {{signer.email}}
                              </div>
                            </div>
                          </div>
                          <div class="d-flex flex-wrap  align-items-center col-5">
                            <div class="col-md-7 col-12 col-sm-6 fs-14 font-weight-500">
                              @if (signer.signedAt) {
                                <label class="fs-13">{{signer.signedAt | localizedDate | async}}</label>
                              }
                            </div>
                            <div class="col-md-4 col-12 col-sm-5" [ngClass]="{'ms-4': signer.email == signatureReportData?.signer && !signer.signed && !isMobile, 'ms-1': signer.email == signatureReportData?.signer && !signer.signed && isMobile}">
                              @if (signer.email == signatureReportData?.signer) {
                                <div>
                                  @if (!signer.signed) {
                                    <button class="v-btn btn btn-primary fs-12 font-weight-600 text-white sign-button" (click)="openSignatureModal(signer)">{{ 'MAIN.CONTENT.REPORT.APPROVAL.SIGN' | translate }}</button>
                                  }
                                  @if (signer.signed) {
                                    <div class="p-relative cursor-pointer" [ngStyle]="{'min-height': isMobile ? '80px' : '80px','min-width': isMobile ? '100px' : '120px'}">
                                      <div class="view">
                                        @if (signer.signed) {
                                          <img [src]="signer.signatureUrl" alt="" class="tt">
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                              @if (signer.email !== signatureReportData?.signer) {
                                <div class="" >
                                  @if (!signer.signed) {
                                    <div class="d-flex flex-column align-items-center">
                                      <label class="fs-14 font-weight-600">{{ 'MAIN.CONTENT.REPORT.APPROVAL.NOT-SIGNED' | translate }}</label>
                                    </div>
                                  }
                                  @if (signer.signed) {
                                    <div class="p-relative cursor-pointer" [ngStyle]="{'min-height': isMobile ? '80px' : '80px','min-width': isMobile ? '110px' : '120px'}">
                                      <div class="view">
                                        @if (signer.signed) {
                                          <img [src]="signer.signatureUrl" alt="" class="tt">
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }

        <ng-template #reportHeaderVsight>
          <div class="p-relative">
            @if (!isMobile && !signatureReportData) {
              <div style="position: absolute;right: 45px;top: 15px;" class="close">
                <img src="assets/img/close-circle.svg" alt="" (click)="onClose()" class="close-circle">
              </div>
            }
          </div>
          <div style="margin-left: 46px;margin-top: 50px;">
            @if (!logoList?.[accountName]) {
              <img src="assets/img/logo.png" alt="" width="200px">
            }
            @if (logoList?.[accountName]) {
              <img [src]="$safeNavigationMigration(logoList?.[accountName].logo)" alt="" width="200px">
            }
          </div>
        </ng-template>

        <ng-template #reportHeaderEwers>
          <div class="p-relative">
            @if (!isMobile && !signatureReportData) {
              <div class="d-flex justify-content-end me-5 mt-3">
                <img src="assets/img/close-circle.svg" alt="" (click)="onClose()" class="cursor-pointer close-circle">
              </div>
            }
          </div>
          <div class="d-flex justify-content-end me-5 logo-display mb-4">
            <img src="assets/img/ewers.png" alt="" width="200px">

          </div>

        </ng-template>

        <ng-template #loadingTemplate>
          <div class="spinner-border mb-4" role="status" style="margin-left:100px">
            <span class="visually-hidden">{{ 'MAIN.CONTENT.REPORT.LOADING' | translate }}</span>
          </div>
        </ng-template>
